import { render, staticRenderFns } from "./MultiForm.vue?vue&type=template&id=9600a2f2&scoped=true"
import script from "./MultiForm.vue?vue&type=script&lang=js"
export * from "./MultiForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9600a2f2",
  null
  
)

export default component.exports